export default __webpack_public_path__ + "static/media/slider_img.1a745af5.png";